import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const StripeOnboardingComplete = () => {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    // Wait a moment for Stripe to process, then check status
    const timer = setTimeout(() => {
      checkStatus();
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const checkStatus = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/drivers/stripe/status`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setStatus(response.data);
    } catch (err) {
      console.error('Status check error:', err);
    } finally {
      setChecking(false);
    }
  };

  const handleContinue = () => {
    if (status?.payouts_enabled) {
      navigate('/driver/dashboard');
    } else {
      navigate('/driver/onboarding');
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        {checking ? (
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Verifying Your Account
            </h2>
            <p className="text-gray-600">
              Please wait while we confirm your information with Stripe...
            </p>
          </div>
        ) : status?.payouts_enabled ? (
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              All Set!
            </h2>
            <p className="text-gray-600 mb-6">
              Your payout account has been successfully connected. You can now receive earnings from completed rides.
            </p>
            <button
              onClick={handleContinue}
              className="w-full py-3 px-6 bg-green-600 text-white rounded-lg font-semibold hover:bg-green-700 transition"
            >
              Go to Dashboard
            </button>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Almost There!
            </h2>
            <p className="text-gray-600 mb-6">
              {status?.onboarding_required
                ? 'Your account setup is incomplete. Please complete the required information.'
                : 'Your account is being reviewed. This usually takes just a few minutes.'}
            </p>
            <button
              onClick={handleContinue}
              className="w-full py-3 px-6 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition"
            >
              {status?.onboarding_required ? 'Complete Setup' : 'Check Status'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default StripeOnboardingComplete;
